// Mock data for different race categories
const marketCapRaces = [
  {
    id: "48096540",
    title: "2024 Token Race",
    amount: 1875,
    type: "marketCap",
    timeLeft: { hours: 2, minutes: 30, seconds: 0 },
    poolData: [
      { symbol: "BTC", odds: 5.1, poolSize: 500 },
      { symbol: "ETH", odds: 10.1, poolSize: 375 },
      { symbol: "XRP", odds: 3.1, poolSize: 1000 },
      { symbol: "BNB", odds: 3.1, poolSize: 500 },
      { symbol: "SOL", odds: 3.1, poolSize: 500 },
    ],
  },
  {
    id: "48096541",
    title: "2024 Token Race",
    amount: 2250,
    type: "marketCap",
    timeLeft: { hours: 1, minutes: 45, seconds: 0 },
    poolData: [
      { symbol: "BTC", odds: 4.2, poolSize: 600 },
      { symbol: "ETH", odds: 8.5, poolSize: 425 },
      { symbol: "XRP", odds: 3.8, poolSize: 900 },
      { symbol: "BNB", odds: 3.5, poolSize: 550 },
      { symbol: "SOL", odds: 2.8, poolSize: 600 },
    ],
  },
];

const altcoinRaces = [
  {
    id: "48096542",
    title: "2024 Altcoin Race",
    amount: 1500,
    type: "altcoin",
    timeLeft: { hours: 3, minutes: 15, seconds: 0 },
    poolData: [
      { symbol: "DOT", odds: 4.5, poolSize: 400 },
      { symbol: "LINK", odds: 7.2, poolSize: 325 },
      { symbol: "ADA", odds: 3.8, poolSize: 800 },
      { symbol: "MATIC", odds: 4.1, poolSize: 450 },
      { symbol: "ATOM", odds: 3.4, poolSize: 475 },
    ],
  },
];

const memecoinRaces = [
  {
    id: "48096543",
    title: "2024 Meme Race",
    amount: 1200,
    type: "meme",
    timeLeft: { hours: 1, minutes: 0, seconds: 0 },
    poolData: [
      { symbol: "DOGE", odds: 6.2, poolSize: 300 },
      { symbol: "SHIB", odds: 8.5, poolSize: 250 },
      { symbol: "PEPE", odds: 4.5, poolSize: 700 },
      { symbol: "FLOKI", odds: 5.1, poolSize: 400 },
      { symbol: "BONE", odds: 4.8, poolSize: 450 },
    ],
  },
];

const defiRaces = [
  {
    id: "48096544",
    title: "2024 DeFi Race",
    amount: 1650,
    type: "defi",
    timeLeft: { hours: 4, minutes: 30, seconds: 0 },
    poolData: [
      { symbol: "UNI", odds: 5.5, poolSize: 450 },
      { symbol: "AAVE", odds: 9.2, poolSize: 275 },
      { symbol: "MKR", odds: 4.2, poolSize: 850 },
      { symbol: "SNX", odds: 3.8, poolSize: 500 },
      { symbol: "COMP", odds: 3.5, poolSize: 525 },
    ],
  },
];

// All races combined
const allRaces = [
  ...marketCapRaces,
  ...altcoinRaces,
  ...memecoinRaces,
  ...defiRaces,
];

// Simulate API delay
const simulateDelay = () => new Promise((resolve) => setTimeout(resolve, 800));

// Get races by type
export async function getRacesByType(type) {
  await simulateDelay();

  switch (type) {
    case "marketCap":
      return marketCapRaces;
    case "altcoin":
      return altcoinRaces;
    case "meme":
      return memecoinRaces;
    case "defi":
      return defiRaces;
    default:
      return allRaces;
  }
}

// Get all races
export async function getAllRaces() {
  await simulateDelay();
  return allRaces;
}

// Get race by ID
export async function getRaceById(id) {
  await simulateDelay();
  return allRaces.find((race) => race.id === id);
}

// Get featured races (top 4 by pool size)
export async function getFeaturedRaces() {
  await simulateDelay();
  return allRaces.sort((a, b) => b.amount - a.amount).slice(0, 4);
}

// Search races by title or token
export async function searchRaces(query) {
  await simulateDelay();
  const lowercaseQuery = query.toLowerCase();

  return allRaces.filter(
    (race) =>
      race.title.toLowerCase().includes(lowercaseQuery) ||
      race.poolData.some((token) =>
        token.symbol.toLowerCase().includes(lowercaseQuery)
      )
  );
}

// Get total active races count
export async function getActiveRacesCount() {
  await simulateDelay();
  return allRaces.length;
}

// Get total pool size across all races
export async function getTotalPoolSize() {
  await simulateDelay();
  return allRaces.reduce((total, race) => total + race.amount, 0);
}

export async function getFilters() {
  await simulateDelay();
  return [
    { id: "all", label: "All" },
    { id: "marketCap", label: "Market Cap" },
    { id: "altcoin", label: "Altcoins" },
    { id: "meme", label: "Memecoins" },
    { id: "defi", label: "DeFi" },
  ];
}
